(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.kafResizeVideo = {
    attach: () => {
      const centerVideo = () => {
        let containerHeight = $('.hero').height();
        let containerWidth = $('.hero').width();
        let containerRatio = 1 / 2;
        let videoHeight = containerWidth * containerRatio;
        let heightDiff = containerHeight - videoHeight;
        heightDiff = Math.round(heightDiff / 2) + 'px';
        if (window.innerWidth >= 768) {
          $('.hero__video > figure').css('top', heightDiff);
        }
        else {
          $('.hero__video > figure').css('top', '');
        }
      };

      centerVideo();

      $(window).on('resize', centerVideo);
    }
  };
})(jQuery, Drupal);
